const formDefaultData = {
    name: '',
    sexCd: 'M',
    birthDay:'',
    hpNo: '',
    customerNm: '',
    voucherCode: ''
};

export default formDefaultData;